const Banner = ({ docType = "API", href }) => {
  return (
    <section className="banner">
      <h3>
        Good news! We have created a new and interactive {docType} documentation
        portal located here{" "}
        <a
          rel="alternate"
          aria={`link to the newly released ${docType.toLowerCase()} docs site`}
          href={href}
        >
          docs.lightcast.io
        </a>
      </h3>
    </section>
  );
};

export default Banner;
